// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q7-5";
export var filledCircle = "_q7-4";
export var historyEntry = "_q7-3";
export var messageSideLeft = "_q7-1";
export var messageSideRight = "_q7-2";
export var orderTrackingCarouselWrapper = "_q7-6";
export var orderTrackingInfoContainer = "_q7-0";